import React from "react";
import ErrorPage from "../../pages/error/Error";
import { appInsights } from "../../core/services/insight.service";


type Props = { children: React.ReactNode };
type State = { hasError: boolean };

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    if (appInsights) {
      appInsights.trackException({
        exception: error,
        properties: { errorInfo }
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;